import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faLinkedin,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { useContact } from "../../Context/ContactContext";

const DEFAULT_EMAIL = "support@roadtofe.com";

const ContactHeader = () => {
  const { contact } = useContact();
  const socialLinks = contact?.socialLinks || {};
  const email = socialLinks?.email || DEFAULT_EMAIL;

  return (
    <div className="bg-[#2A4258] p-3">
      <div className="flex justify-between px-6">
        <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-10">
          <span className="flex items-center gap-2 text-white text-sm">
            <FontAwesomeIcon icon={faEnvelope} />
            <a href={`mailto:${email}`} className="hover:text-gray-200">
              {email}
            </a>
          </span>
        </div>
        <div className="flex">
          <span className="flex items-center gap-6 text-white">
            {socialLinks?.linkedin && (
              <a
                href={socialLinks.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-gray-200"
                aria-label="LinkedIn"
              >
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
            )}
            {socialLinks?.facebook && (
              <a
                href={socialLinks.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-gray-200"
                aria-label="Facebook"
              >
                <FontAwesomeIcon icon={faFacebook} />
              </a>
            )}
            {socialLinks?.youtube && (
              <a
                href={socialLinks.youtube}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-gray-200"
                aria-label="YouTube"
              >
                <FontAwesomeIcon icon={faYoutube} />
              </a>
            )}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ContactHeader;
